import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

const useFetchingMyTickets = () => {
  const result = useQuery({
    queryKey: ["my-tickets"],
    queryFn: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) return [];
      const { data, error } = await supabase
        .from("tickets")
        .select(
          `
          quantity,
          payment_method,
          total_price,
          created_at,
          status,
          refunded_at,
          credits_spent,
          events (
            id,
            title,
            credit_cost,
            start_time
          )
        `
        )
        .eq("user_id", user.id)
        .in("status", ["confirmed", "refunded"])
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  return result
};

export default useFetchingMyTickets;
